<section class="bg-primary bg-[url('/assets/img/theme-bg.webp')] text-white">
  <div class="flex justify-center bg-black/20 p-8">
    <div
      class="w-full grid gap-8 max-w-screen-lg md:grid-cols-2 md:justify-between lg:grid-cols-4"
    >
      <div>
        <h2 class="font-extrabold" i18n>Links</h2>
        <div class="h-1 w-10 bg-secondary mt-2 mb-4"></div>
        <a
          class="block hover:text-secondary-300"
          i18n-routerLink="@@//terms-and-conditions"
          routerLink="/terms-and-conditions"
          target="_blank"
          i18n
        >
          General Terms and Conditions
        </a>
        <a
          class="block hover:text-secondary-300"
          i18n-routerLink="@@//terms-of-use"
          routerLink="/terms-of-use"
          target="_blank"
          i18n
        >
          Terms of Use
        </a>
        <a
          class="block hover:text-secondary-300"
          i18n-routerLink="@@//privacy"
          routerLink="/privacy"
          target="_blank"
          i18n
        >
          Privacy declaration
        </a>
        <a
          class="block hover:text-secondary-300"
          i18n-routerLink="@@//faq"
          routerLink="/faq"
          i18n
        >
          FAQ
        </a>
        <a
          class="block hover:text-secondary-300"
          i18nRouterLink="/integrity"
          target="_blank"
          i18n
        >
          Integrity Policy
        </a>
        <a
          class="block hover:text-secondary-300"
          i18nRouterLink="/report"
          target="_blank"
          i18n
        >
          Integrity Report
        </a>
        <button
          class="text-start block hover:text-secondary-300"
          (click)="auth.loginWithRedirect()"
          i18n
        >
          Register
        </button>
      </div>
      <div>
        <h2 class="font-extrabold" i18n>Services</h2>
        <div class="h-1 w-10 bg-secondary mt-2 mb-4"></div>
        <a
          class="block hover:text-secondary-300"
          i18n-routerLink="@@//courses"
          routerLink="/courses"
          i18n
        >
          Camps
        </a>
        <a
          class="block hover:text-secondary-300"
          i18nRouterLink="/after-school"
          i18n
        >
          After-school lessons
        </a>
        <a
          class="block hover:text-secondary-300"
          i18nRouterLink="/workshops"
          i18n
        >
          Workshops
        </a>
      </div>
      <div>
        <h2 class="font-extrabold" i18n>Phone</h2>
        <div class="h-1 w-10 bg-secondary mt-2 mb-4"></div>
        <div class="flex flex-col gap-2 mb-4 items-start">
          <div class="flex gap-2 items-center">
            <div
              class="flex h-10 w-10 justify-center items-center bg-teal-300 rounded-md"
            >
              <mat-icon>call</mat-icon>
            </div>
            <div class="flex flex-col items-center">
              <span i18n>+32 (0) 3 375 50 12</span>
            </div>
          </div>

          <div>
            <p i18n>During non camp weeks:</p>
            <p class="pl-2" i18n>Mon-Thu: 9u-17u</p>
          </div>

          <div>
            <p i18n>During camp weeks:</p>
            <p class="pl-2" i18n>Campdays: 8u-18u</p>
          </div>
        </div>
      </div>
      <div>
        <h2 class="font-extrabold" i18n>Contact</h2>
        <div class="h-1 w-10 bg-secondary mt-2 mb-4"></div>
        <div class="flex flex-col gap-2 mb-4 items-start">
          <div class="flex gap-2 items-center">
            <div
              class="flex h-10 w-10 justify-center items-center bg-teal-300 rounded-md"
            >
              <mat-icon>house</mat-icon>
            </div>
            <div class="flex flex-col">
              <span i18n>Ter Rivierenlaan 103</span>
              <span i18n>2100 Deurne</span>
            </div>
          </div>
          <a
            mat-ripple
            i18n-routerLink="@@//contact-us"
            routerLink="/contact-us"
            class="group h-10 w-52 p-1 flex gap-2 bg-white rounded-md hover:bg-secondary transition-colors duration-75"
          >
            <div
              class="flex justify-center items-center bg-secondary text-white rounded-md p-1"
            >
              <mat-icon>send</mat-icon>
            </div>
            <span class="flex justify-center items-center text-black" i18n>
              Contact us
            </span>
          </a>
        </div>
        <span i18n>Follow us:</span>
        <app-frontend-socials></app-frontend-socials>
      </div>
    </div>
  </div>
</section>
